import { render } from "./GraphicDesign.vue?vue&type=template&id=1b0508fb&scoped=true"
import script from "./GraphicDesign.vue?vue&type=script&lang=js"
export * from "./GraphicDesign.vue?vue&type=script&lang=js"

import "./GraphicDesign.vue?vue&type=style&index=0&id=1b0508fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0508fb"]])

export default __exports__